import template from './amenities.jade';
import amenitiesCtrl from './amenities.controller';

export default () => {
  return {
    template,
    scope: {},
    bindToController: {
      ad: '=',
    },
    controller: amenitiesCtrl,
    controllerAs: 'amenitiesCtrl',
    replace: true,
  };
};
